import { HighLowIndex } from '../high-low/const';

export const securityTypeOptions: { value: HighLowIndex; label: string }[] = [
    { value: HighLowIndex.MoscowExchangesIndex, label: 'Индекс МосБиржи' },
    { value: HighLowIndex.MoscowExchangeBlueChipIndex, label: 'Индекс Голубых фишек' },
    { value: HighLowIndex.ETF, label: 'ETF' },
    { value: HighLowIndex.Top100, label: 'Топ-100' },
];

export enum Time {
    d1 = 'd1',
    w1 = 'w1',
    m1 = 'm1',
    y1 = 'y1',
    yTD = 'yTD',
}

export const timeMapper: Record<Time, string> = {
    d1: '1D',
    w1: '1W',
    m1: '1M',
    y1: '1Y',
    yTD: 'YTD',
};

export const timeOptions: { value: Time; label: string }[] = [
    { value: Time.d1, label: timeMapper[Time.d1] },
    { value: Time.w1, label: timeMapper[Time.w1] },
    { value: Time.m1, label: timeMapper[Time.m1] },
    { value: Time.y1, label: timeMapper[Time.y1] },
    { value: Time.yTD, label: timeMapper[Time.yTD] },
];
